const PERU = {
  ISO2: 'PE',
  ISO3: 'PER',
  nombre: 'PERU'
}

const __dictionary = {
  [PERU.ISO2]: PERU
}

const __array = [__dictionary[PERU.ISO2]]

export default Object.freeze({
  PERU,
  __dictionary,
  __array
})
